import { writable } from "svelte/store";

export interface UserDetails {
  street: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  latitude: number | null;
  longitude: number | null;
  addressString: string;
  email: string;
  submitted: boolean;
}

const initialState: UserDetails = {
  street: "",
  city: "",
  state: "",
  zipCode: "",
  country: "",
  latitude: null,
  longitude: null,
  addressString: "",
  email: "",
  submitted: false,
};

/**
 * User details store
 */
function createUserDetailsStore() {
  const { subscribe, set, update } = writable<UserDetails>(initialState);

  return {
    subscribe,

    setAddress: (
      street: string,
      city: string,
      state: string,
      zipCode: string,
      country: string,
      latitude: number,
      longitude: number,
      addressString: string,
    ) =>
      update((store) => ({
        ...store,
        street,
        city,
        state,
        zipCode,
        country,
        latitude,
        longitude,
        addressString,
      })),

    setEmail: (email: string) =>
      update((store) => ({
        ...store,
        email,
      })),

    setSubmitted: (submitted: boolean) =>
      update((store) => ({
        ...store,
        submitted,
      })),

    reset: () => set(initialState),
  };
}

export const userDetails = createUserDetailsStore();
